{{ value | cbDasher }}
